import type { ReactNode } from 'react';
import { Cancel, CheckCircle, Pending } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import {
    getEventPublishIconTooltip,
    type EventPublishIconKind,
} from '../utils/eventCardStatus';

interface EventPublishStatusIconProps {
    kind: EventPublishIconKind;
    fontSize?: number;
}

export const EventPublishStatusIcon = ({ kind, fontSize = 22 }: EventPublishStatusIconProps) => {
    const sx = { fontSize };
    const tooltip = getEventPublishIconTooltip(kind);

    let icon: ReactNode;
    if (kind === 'canceled') {
        icon = <Cancel sx={{ ...sx, color: 'error.main' }} aria-label="Cancelled" />;
    } else if (kind === 'published') {
        icon = <CheckCircle sx={{ ...sx, color: 'success.main' }} aria-label="Published" />;
    } else {
        icon = <Pending sx={{ ...sx, color: 'pending.main' }} aria-label="Not published" />;
    }

    return (
        <Tooltip title={tooltip} arrow placement="top">
            <span style={{ display: 'inline-flex', lineHeight: 0 }}>{icon}</span>
        </Tooltip>
    );
};
